import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { delay, retryWhen, scan, take, tap } from 'rxjs/operators';
import { SourcesInsertService } from '~shared/services/sources-insert.service';
import { FlyoutMenuStatus } from '~app/modules/authorization/models/flyout-menu-status.model';
import { authCSSEndpoints } from '~app/modules/authorization/constants/authorization.constant';
import { HttpClient } from '@angular/common/http';
import { POLL_CHECK_STATUS_INTERVAL, POLL_RETRY_LIMIT } from '../constants/flyout.constant';
import { ApiConfig, NUMBER_1 } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class AccountFlyoutService {
  private unsubscribe$ = new Subject<void>();
  public pendingForceRefresh$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly sourceInsertService: SourcesInsertService,
    private httpClient: HttpClient
  ) {
  }

  public pollFlyoutStatusUpdate$(handle: string): Observable<FlyoutMenuStatus> {
    const pollingInterval = POLL_CHECK_STATUS_INTERVAL;
    const retryLimit = POLL_RETRY_LIMIT;
    const isFlyoutUpdated$ = this.httpClient.get(authCSSEndpoints().flyoutStatus(handle));

    return isFlyoutUpdated$.pipe(
      tap((res: FlyoutMenuStatus) => {
        if (!res.upToDate) {
          throw res;
        }
      }),
      retryWhen(errors => errors.pipe(
        delay(pollingInterval),
        scan((attempts) => {
          if (attempts > 0) {
            return attempts - NUMBER_1;
          }
          throw errors;
        }, retryLimit)
      ))
    );
  }

  public forceRefreshFlyout(): void {
    this.httpClient.get(ApiConfig.SVC_ACCOUNT_INFO_FLYOUT_REFRESH_ENDPOINT(), {
      withCredentials: true,
    }).pipe(
      take(1)
    ).subscribe((e) => {
      this.pendingForceRefresh$.next(true);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
